import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Parse a date string in YYYY-MM-DD format to a Date object
 * Handles local timezone correctly
 */
export function parseLocalDate(dateString: string): Date {
  if (!dateString) {
    return new Date()
  }
  
  // Parse YYYY-MM-DD format
  const parts = dateString.split('-')
  if (parts.length !== 3) {
    return new Date(dateString)
  }
  
  const year = parseInt(parts[0], 10)
  const month = parseInt(parts[1], 10) - 1 // Month is 0-indexed
  const day = parseInt(parts[2], 10)
  
  // Create date in local timezone
  return new Date(year, month, day)
}
